import React, { useState, useEffect, useRef } from 'react';
import Header from "../../../Components/Header/Header.js";
import LeftMenu from '../../../Components/LeftMenu/LeftMenu.js';
import TopMenu from '../../../Components/TopMenu/TopMenu.js';
import AirFreight from './AirFreight.js'; 
import SeaFreight from './SeaFreight.js';
import AddExport from '../ShipmentManager/Components/Common/AddExport.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom'; 
import Inbox from './Inbox.js';

const Quotation = () => { 

  const initialTab = localStorage.getItem("MainTab") || 'arf';   
  const isMounted = useRef(false);
  const [mainTab, setMainTab] = useState(initialTab);
  const initPage = localStorage.getItem("QUTpage") || '';
  const [innerPage, setInnerPage] = useState(initPage);

  const handleMainClick = (button) => {
    setMainTab(button);
    localStorage.setItem('MainTab', button);
  };

  const handlenewLink = (page = '', main = null) => {
    setInnerPage(page);
    localStorage.setItem('QUTpage', page);

    if (main) {
      setMainTab(main);
      localStorage.setItem('MainTab', main);
    }
  };

  return (
    <div className="">
      {/* {console.log("check check")}
      {console.log('mainTab',mainTab)} */}
      <Header page_type='qut' logo_url='/Quotation' />
      <div className="page-body-wrapper schedule">
        <LeftMenu />
        {innerPage === '' &&
          <div className="main-panel rounded">
            <div className="mainTab">
              <TopMenu module='QUT' onTab={handleMainClick} selectedTab={mainTab} />
              <div className="">
                <div className="allcontent-fl">
                  <div className='d-flex justify-content-between mb-3'>

                  </div>
                  <div className="lcontent">
                    {mainTab === 'arf' && <AirFreight onAddClick={() => handlenewLink('add')} />}
                    {mainTab === 'sef' && <SeaFreight onAddClick={() => handlenewLink('add')} />}
                    {mainTab === 'ibx' && <Inbox />}
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
        {innerPage === 'add' &&
          <div className="main-panel rounded">
            <Link to="#" className='stk_back' onClick={() => handlenewLink('')}> <FontAwesomeIcon icon={faArrowLeft} /> Back</Link>
            {/* <button className='stk_back' onClick={() => handlenewLink('')}>
              <FontAwesomeIcon icon={faArrowLeft} /> Back
            </button> */}
            <div className='mb-3 mt-3'>
              <AddExport goParent={() => handlenewLink('', 'arf')} />
            </div>
          </div>
        }
      </div>
    </div>
  )
}

export default Quotation;